<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="status" class="w150" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">视频标题</span>
        <el-input v-model.trim="title" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getVideoMinePageFn()">
          搜索
        </el-button>
        <el-button type="primary" @click="labelBtn">
          标签设置
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" type="index" width="50" label="序号"></el-table-column>
      <el-table-column align="center" prop="title" label="视频标题"></el-table-column>
      <el-table-column align="center" prop="browseNum" label="点击量"></el-table-column>
      <el-table-column align="center" prop="collectionNum" label="收藏数"></el-table-column>
      <el-table-column align="center" prop="commentsNum" label="评论数"></el-table-column>
      <el-table-column align="center" prop="forwardNum" label="转发数"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="statusName" label="审核状态"></el-table-column>
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="editBtb(row.videoId, 1)">查看</a>
          <a class="glob-a" v-if="row.status == '2'" @click="editBtb(row.videoId, 2)">置顶</a>
          <a class="glob-a" v-if="row.status == '5'" @click="editBtb(row.videoId, 3)">取消置顶</a>
          <template v-if="row.status == '3' || row.status == '4'">
            <a class="glob-a" @click="editBtb(row.videoId, 4)">编辑</a>
            <a class="glob-a" @click="editBtb(row.videoId, 5)">删除</a>
          </template>
          <a class="glob-a" v-if="row.status == '2' || row.status == '5'" @click="editBtb(row.videoId, 6)">下架</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 置顶 -->
    <el-dialog title="置顶" :visible.sync="topData.modal" width="500px">
      <el-form style="min-height: 50px;">
        <el-form-item label="置顶日期" label-width="100px">
          <el-date-picker
              v-model="topData.date"
              style="width: 300px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="topData.modal = false">取 消</el-button>
        <el-button type="primary" @click="topSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看 -->
    <el-dialog title="查看" :visible.sync="detailModal" fullscreen>
      <detail :data="detailData"/>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog title="编辑" :visible.sync="formData.modal" fullscreen>
      <el-form ref="refForm" :model="formData" class="mt20" label-width="200px">
        <el-form-item label="视频标题：" prop="title" :rules="rules">
          <el-input v-model="formData.title" placeholder="请在这里输入标题(6~30个字" maxlength="30"/>
        </el-form-item>
        <el-form-item label="视频简介：" prop="content" :rules="rules">
          <el-input v-model="formData.content" placeholder="请输入" type="textarea" :rows="6" resize="none"/>
        </el-form-item>
        <el-form-item label="选择视频：" prop="videoType" :rules="rules">
          <el-radio v-model="formData.videoType" label="LOCAL">本地视频</el-radio>
          <el-radio v-model="formData.videoType" label="EXTERNAL">链接视频</el-radio>

          <my-video
              class="mt10"
              v-show="formData.videoType == 'LOCAL'"
              v-model="formData.videoUrl"
              unlimited
          />
          <div v-show="formData.videoType == 'LOCAL'" class="font12 c-999">
            <p>
              上传视频：目前仅支持mp4、rmvb、avi3种视频格式。视频大小、时长理论上无限制，但会影响上传速度和播放效果，请酌情处理
            </p>
            <p>
              站外链接：支持优酷、爱奇艺视频链接和三方服务器存储的视频，可能会存在视频广告、播放失败等因素，具体发布结果以审核和实际效果为准，请知悉
            </p>
          </div>

          <el-input
              v-show="formData.videoType == 'EXTERNAL'"
              v-model="formData.videoLink"
              class="mt10"
              placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="标签：">
          <el-select v-model="formData.label" multiple :multiple-limit="5" placeholder="请选择">
            <el-option
                v-for="item in labelList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="置顶：">
          <el-radio-group v-model="formData.top">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="置顶日期：">
          <el-date-picker
              v-model="formData.topDate"
              style="width: 300px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item class="mt55">
          <el-button @click="formData.modal = false">取 消</el-button>
          <el-button type="primary" @click="saveBtn">提交审核</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 标签 -->
    <el-dialog title="标签" :visible.sync="labelData.modal" width="500px">

      <div class="text-center">
        <el-input v-model.trim="labelData.value" placeholder="请输入" maxlength="9" style="width: 250px;"/>
        <el-button class="ml10" @click="addLabel" type="primary">添加</el-button>
      </div>

      <div class="mt20">
        <el-tag
            v-for="item in labelList"
            :key="item.labelId"
            closable
            class="mr10 mb10"
            size="medium"
            :disable-transitions="false"
            @close="labelClose(item.labelId)">
          {{item.labelName}}
        </el-tag>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getVideoMinePage,
    setVideoAuthCancelTop,
    setVideoAuthSoldOut,
    setVideoAuthTop,
    delVideoMine,
    getVideoAuthMsg,
    getVideoMineLabel,
    addVideoMineLabel,
    delVideoMineLabel,
    setVideo
  } from '@/api'

  import Detail from './Detail'
  import MyVideo from '@/components/MyVideo.vue'

  export default {
    name: 'VideoPlatform',
    components: {Detail, MyVideo},
    data () {
      return {
        rules: this.$store.state.rules.required,
        date: [],
        title: '',
        status: '',
        statusList: [
          {name: '待审核', value: '1'},
          {name: '已发布', value: '2'},
          {name: '未通过', value: '3'},
          {name: '已下架', value: '4'},
          {name: '置顶中', value: '5'},
        ],
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        topData: {
          modal: false,
          id: '',
          date: [],
        },
        detailModal: false,
        detailData: {},
        // 编辑数据
        formData: {
          modal: false,
          videoId: '',
          title: '',
          content: '',
          videoType: 'LOCAL',
          videoLink: '',
          videoUrl: '',
          label: [],
          top: 'Y',
          topDate: [],
        },
        labelList: [],
        labelData: {
          modal: false,
          value: ''
        }
      }
    },
    created () {
      this.getVideoMinePageFn()
      this.getVideoMineLabelFn()
    },
    methods: {
      addLabel () {
        if (this.labelData.value) {
          addVideoMineLabel(this.labelData.value).then(res => {
            this.$message.success(res.data)
            this.labelData.value = ''
            this.getVideoMineLabelFn()
          })
        }
      },
      labelClose (id) {
        delVideoMineLabel(id).then(res => {
          this.$message.success(res.data)
          this.getVideoMineLabelFn()
        })
      },
      labelBtn () {
        this.labelData = {
          modal: true,
          value: ''
        }
      },
      getVideoMineLabelFn () {
        getVideoMineLabel().then(res => {
          this.labelList = res.data
        })
      },
      saveBtn () {
        this.$refs['refForm'].validate(valid => {
          if (valid) {
            setVideo({
              videoId: this.formData.videoId,
              title: this.formData.title,
              content: this.formData.content,
              videoUrl: this.formData.videoType == 'EXTERNAL' ? this.formData.videoLink : this.formData.videoUrl,
              source: 1,
              labelIds: this.formData.label,
              stickFlag: this.formData.top,
              videoType: this.formData.videoType,
              stickStartTime: this.formData.topDate && this.formData.topDate.length ? this.formData.topDate[0] : '',
              stickEndTime: this.formData.topDate && this.formData.topDate.length > 1 ? this.formData.topDate[1] : '',
            }).then(res => {
              this.$message.success(res.data)
              this.formData.modal = false
              this.getVideoMinePageFn()
            })
          } else {
            return false
          }
        })
      },
      topSave () {
        setVideoAuthTop({
          videoId: this.topData.id,
          stickStartTime: this.topData.date && this.topData.date.length ? this.topData.date[0] : '',
          stickEndTime: this.topData.date && this.topData.date.length > 1 ? this.topData.date[1] : '',
        }).then(res => {
          this.$message.success(res.data)
          this.topData.modal = false
          this.getVideoMinePageFn()
        })
      },
      // 1)查看 2)置顶  3)取消置顶 4)编辑 5)删除 6)下架
      editBtb (id, t) {
        switch (t) {
          case 1:
            getVideoAuthMsg(id).then(res => {
              this.detailModal = true
              this.detailData = res.data
            })
            break
          case 2:
            this.topData = {
              modal: true,
              id,
              date: [],
            }
            break
          case 3:
            this.$confirm('确认取消置顶吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setVideoAuthCancelTop(id).then(res => {
                this.$message.success(res.data)
                this.getVideoMinePageFn()
              })
            }).catch(() => {
            })
            break
          case 4:
            getVideoAuthMsg(id).then(res => {
              this.formData = {
                modal: true,
                videoId: id,
                title: res.data.title,
                content: res.data.content,
                videoType: res.data.videoType,
                videoLink: res.data.videoType == 'EXTERNAL' ? res.data.videoUrl : '',
                videoUrl: res.data.videoType == 'LOCAL' ? res.data.videoUrl : '',
                label: res.data.labelName.map(item => item.labelId),
                top: res.data.stickFlag,
                topDate: res.data.stickFlag == 'Y' ? [res.data.stickStartTime, res.data.stickEndTime] : [],
              }
            })
            break
          case 5:
            this.$confirm('确认删除视频吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delVideoMine(id).then(res => {
                this.$message.success(res.data)
                this.getVideoMinePageFn()
              })
            }).catch(() => {
            })
            break
          case 6:
            this.$prompt('下架原因', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /\S/,
              inputPlaceholder: '请输入',
              inputErrorMessage: '请输入'
            }).then(({value}) => {
              setVideoAuthSoldOut({
                videoId: id,
                remark: value
              }).then(res => {
                this.$message.success(res.data)
                this.getVideoMinePageFn()
              })
            }).catch(() => {
            })
            break
        }
      },
      getVideoMinePageFn () {
        this.tableLoading = true
        getVideoMinePage({
          title: this.title,
          status: this.status,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getVideoMinePageFn()
      },
    }
  }
</script>

<style scoped>

</style>
